module.exports = function (bootstrap) {
  bootstrap.run([
    "Service",
    function (Service) {
      var envMapping = {
        env3: "beta",
        env2: "beta",
        envb: "beta",
        env6: "beta",
        env7: "beta",
        env:  "beta",
        env1: "beta",
      };
      var envKey = {
        alpha: "AIzaSyD9XChYMb-mWMF89jxi3GX_Iz6LutrRCNI",
        beta: "AIzaSyCLVuRo6P2w1R4d26zJskX36hoPez1Leno",
        prod:"AIzaSyCGvyjSd-MibxYgChnhwUkkSU-8Y-cp7TY"

      };
      var tempToken;
      // https://alpha.api.highmark.com/core/v1/token/new
      //     https://beta.api.highmark.com/core/v1/token/new
      //         https://pre-prod.api.highmark.com/core/v1/token/new
      //             https://prod.api.highmark.com/core/v1/token/new

      var envSplit = location.host.split("."); // tenv3.highmarkbcbs.com
      var env = envSplit[0].substring(1),
        envMapped = env == "ww" ? "prod" : envMapping[env],
       // currentKey = envMapped == "prod" ? "" : envKey[envMapped],
       currentKey = envKey[envMapped],
        envPath =
          "https://" + envMapped + ".api.highmark.com/core/v1/token/new";
          var currentConfig =env == 'ww'? "prod":"beta",
          updateEnvPath = 'https://'+ currentConfig + '.api.highmark.com/user-attributes/v2/modify-user';
      return new Service({
        name: "fireBaseToken",
        group: "eprsvc",
        url: envPath,
        
        getTempToken: function (postBody) {
          tempToken = this.post(postBody);
          return tempToken;
        },
        getFirebaseToken: function (dataVal) {
          var postBody = {
            token: dataVal.token,
            returnSecureToken: true,
          };
         this.headers={};
         this.withCredentials = false;
          this.url =
            "https://identitytoolkit.googleapis.com/v1/accounts:signInWithCustomToken?key=" +
            currentKey;
          return this.post(postBody);
        },
        updateUser: function(reqBody,idToken){            
              this.headers= {
                  "x-auth-token": idToken,
                  APPID:""};
              this.url = updateEnvPath;  
              this.withCredentials = true;         
         return this.post(reqBody);
      }
      });
    },
  ]);
};
